window.onload = function () {

	// Add classes to elements if website is iframed
	if (window.self !== window.top) {
		// Hide login text
		document.querySelector('#login .heading').classList.add("heading--is-hidden");

		// Remove grid padding
		document.querySelector('.grid').classList.add("grid--is-iframed");
	}

	var postMessage = '';

	// Add body height to postmessage
	postMessage += document.body.scrollHeight + '';

	// Add login block position to postmessage
	var loginBlockCoords = document.getElementById("login").getBoundingClientRect();
	postMessage += '|' + loginBlockCoords.top + ',' + loginBlockCoords.left + ',' + loginBlockCoords.width + ',' + loginBlockCoords.height;

	// Send post message to parent frame onload
	sendDataToParentFrame(postMessage);


	// Send post message to parent frame onresize
	window.onresize = function () {
		var postMessage = '';

		// Add body height to postmessage
		postMessage += document.body.scrollHeight + '';

		// Add login block position to postmessage
		var loginBlockCoords = document.getElementById("login").getBoundingClientRect();

		postMessage += '|' + loginBlockCoords.top + ',' + loginBlockCoords.left + ',' + loginBlockCoords.width + ',' + loginBlockCoords.height;

		// Send post message to parent frame onload
		sendDataToParentFrame(postMessage);
	}

	function sendDataToParentFrame(postMessage) {
		window.parent.postMessage(postMessage, '*');
	}
};